import React from 'react';
import AppNavbar from './components/Navbar';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Products from './components/Products';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Cart from './components/Cart';

import { CartProvider } from './context/CartContext';
import FloatingCartButton from './components/FloatingCartButton';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';
import FloatingInstagramButton from './components/FloatingInstagramButton';
import CartToast from './components/CartToast';
import MobileCartBar from './components/MobileCartBar';
import ConsentBanner from './components/ConsentBanner';
import { useEffect } from 'react';
import { initAnalytics } from './utils/analytics';
import './styles/App.css';

function App() {
  useEffect(() => {
    // initialize analytics if already consented
    try { initAnalytics(); } catch (_) {}
  }, []);
  return (
    <CartProvider>
      <div>
        <AppNavbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produtos" element={<Products />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/contato" element={<Contact />} />

          <Route path="*" element={<Home />} /> {/* Fallback para Home */}
        </Routes>
        <Footer />
        <FloatingCartButton />
        <FloatingWhatsAppButton />
        <FloatingInstagramButton />
        <CartToast />
        <MobileCartBar />
        <Cart />
        <ConsentBanner />
      </div>
    </CartProvider>
  );
}

export default App;
